<template>
    <div class="collection-ledger">

        <ul class="nav nav-tabs" id="collectionTabs" role="Tablist">
            <li v-for="(item, index) in myCollection" :key="item.id" class="nav-item" role="presentation">
                <button class="nav-link" :class="{ 'active': index === 0 }" :id="'collectible-' + item.id + '-tab'" data-bs-toggle="tab" :data-bs-target="'#collectible-' + item.id" type="button" role="tab" :aria-controls="'collectible-' + item.id" :aria-selected="index === 0">{{ itemType }}<span v-if="myCollection.length > 1"> #{{ index + 1 }}</span></button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link disabled d-none" id="history-tab" data-bs-toggle="tab" data-bs-target="#history" type="button" role="tab" aria-controls="history" aria-selected="false">History</button>
            </li>
        </ul>

        <div class="tab-content" id="collectionTabsContent">
            <div v-for="(item, index) in myCollection" :key="item.id" class="tab-pane fade" :class="{ 'show active': index === 0}" :id="'collectible-' + item.id" role="tabpanel" :aria-labelledby="'collectible-' + item.id + '-tab'">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" colspan="2">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h5 class="h5 fw-bolder">My Logbook <span v-if="myCollection.length > 1"> - {{ itemType }} #{{ index + 1 }}</span></h5>
                                    <button v-if="item.ledger.id" @click="editing = JSON.parse(JSON.stringify(item))" class="btn btn-sm btn-link text-secondary text-decoration-none" data-bs-toggle="modal" data-bs-target="#manageLedger"><i class="fa-regular fa-pencil"></i> Edit</button>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="item.ledger.id">
                        <tr>
                            <th scope="row" class="w-25">Added Date:</th>
                            <td>{{ item.ledger.added_at }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Added By:</th>
                            <td>{{ capitalize(item.ledger.added_method) }}</td>
                        </tr>
                        
                        <tr v-if="item.ledger.added_method === 'bought'">
                            <th scope="row">Price Paid:</th>
                            <td>{{ item.ledger.bought_price }}</td>
                        </tr>
                        <tr v-else-if="item.ledger.added_method === 'trade'">
                            <th scope="row">Trade Details:</th>
                            <td><div v-if="item.ledger.added_trade_id">PIN &amp; POP Trade Event</div></td>
                        </tr>

                        <tr>
                            <th scope="row">Condition:</th>
                            <td>{{ capitalize(item.ledger.condition) }}</td>
                        </tr>
                        <template v-if="item.ledger.custom">
                        <tr v-for="field in item.ledger.custom" :key="field.id" v-show="field.value">
                            <th scope="row">{{ field.name }}:</th>
                            <td v-if="field.type === 'boolean'">{{ field.value ? 'YES' : 'NO' }}</td>
                            <td v-else-if="field.type === 'url'"><a :href="field.value" target="_blank" rel="noopener noreferrer nofollow">{{ field.value }}</a></td>
                            <td v-else>{{ field.value }}</td>
                        </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <th scope="row" class="w-25">Added Date:</th>
                            <td class="align-middle text-center" rowspan="4">
                                <p class="fw-bold text-success">Add custom details about this item in your own personal Logbook...</p>
                                <button @click="editing = JSON.parse(JSON.stringify(item))" class="btn btn-sm btn-success text-light" data-bs-toggle="modal" data-bs-target="#manageLedger"><i class="fa-regular fa-notebook"></i> Add Logbook Details</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Price Paid:</th>
                        </tr>
                        <tr>
                            <th scope="row">Condition:</th>
                        </tr>
                        <tr>
                            <th scope="row">Notes:</th>
                        </tr>
                        <!-- <tr>
                            <td>
                                <div class="alert alert-success text-center" role="alert">
                                    <p class="fw-bold">Add custom details about this item in your own personal Logbook...</p>
                                    <button @click="editing = JSON.parse(JSON.stringify(item))" class="btn btn-sm btn-outline-dark" data-bs-toggle="modal" data-bs-target="#manageLedger"><i class="fa-regular fa-notebook"></i> Add Logbook Details</button>
                                </div>
                            </td>
                        </tr> -->
                    </tbody>
                </table>
            </div>
            <div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">...</div>
        </div>



        <div class="modal" id="manageLedger" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit My Logbook:</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body manage-ledger-form">
                        <table class="table table-bordered">
                            <tbody v-if="editing">
                                <tr>
                                    <th scope="row" class="w-25"><label for="added_at" class="form-label">Added Date:</label></th>
                                    <td>
                                        <input type="date" name="added_at" id="added_at" class="form-control logbook-input" placeholder="Date Added" aria-describedby="added-at-tip" v-model="editing.ledger.added_at">
                                        <div id="added-at-tip" class="form-text">WHEN did you acquire this item?</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"><label for="added_method" class="form-label">Added By:</label></th>
                                    <td>
                                        <select name="added_method" id="added_method" class="form-select logbook-input" aria-describedby="added-method-tip" v-model="editing.ledger.added_method">
                                            <option :value="null">Choose One:</option>
                                            <option value="bought">Bought</option>
                                            <option value="trade">Trade</option>
                                            <option value="gift">Gift</option>
                                            <option value="other">Other</option>
                                        </select>
                                        <div id="added-method-tip" class="form-text">HOW did you acquire this item?</div>
                                    </td>
                                </tr>
                                
                                <tr v-if="editing.ledger.added_method === 'bought'">
                                    <th scope="row"><label for="bought_price" class="form-label">Price Paid:</label></th>
                                    <td>
                                        <input type="text" name="bought_price" id="bought_price" class="form-control logbook-input" placeholder="Price Paid" aria-describedby="bought-price-tip" v-model="editing.ledger.bought_price">
                                        <div id="bought-price-tip" class="form-text">How much did you pay for it?</div>
                                    </td>
                                </tr>

                                <tr>
                                    <th scope="row"><label for="condition" class="form-label">Condition:</label></th>
                                    <td>
                                        <select name="condition" id="condition" class="form-select logbook-input" aria-describedby="condition-tip" v-model="editing.ledger.condition">
                                            <option :value="null">Choose One:</option>
                                            <option value="good">Good</option>
                                            <option value="flawed">Flawed</option>
                                            <option value="damaged">Damaged</option>
                                            <option value="fake">Fake</option>
                                        </select>
                                        <div id="condition-tip" class="form-text">What is it's current condition?</div>
                                    </td>
                                </tr>

                                <tr>
                                    <th scope="row"><label for="custom_2" class="form-label">Condition Notes:</label></th>
                                    <td>
                                        <textarea class="form-control logbook-input" id="custom_2" rows="3" placeholder="Enter text" v-model="editing.ledger.custom.find(c => c.id === 2).value"></textarea>
                                    </td>
                                </tr>

                                <tr>
                                    <th scope="row"><label :for="'custom_3'" class="form-label">Backer Card:</label></th>
                                    <td>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input logbook-input" type="checkbox" role="switch" :id="'custom_3'" v-model="editing.ledger.custom.find(c => c.id === 3).value">
                                        </div>
                                    </td>
                                </tr>

                                <tr v-for="(field, index) in editing.ledger.custom" :key="field.id">
                                    <template v-if="field.id !== 2 && field.id !== 3">
                                    <th scope="row"><label :for="'custom_' + field.id" class="form-label">{{ field.name }}:</label></th>
                                    <td v-if="isMember">
                                        <input v-if="field.type === 'text'" type="text" :id="'custom_' + field.id" class="form-control logbook-input" maxlength="128" placeholder="Enter text up to 128 characters" v-model="field.value">
                                        <textarea v-else-if="field.type === 'textarea'" class="form-control logbook-input" :id="'custom_' + field.id" rows="3" placeholder="Enter text" v-model="field.value"></textarea>
                                        <input v-else-if="field.type === 'date'" type="date" :id="'custom_' + field.id" class="form-control logbook-input" v-model="field.value">
                                        <input v-else-if="field.type === 'price'" type="text" :id="'custom_' + field.id" class="form-control logbook-input" placeholder="Enter price" v-model="field.value">
                                        <input v-else-if="field.type === 'number'" type="number" :id="'custom_' + field.id" class="form-control logbook-input" placeholder="Number only" v-model="field.value">
                                        <input v-else-if="field.type === 'url'" type="url" :id="'custom_' + field.id" class="form-control logbook-input" placeholder="URL starting with http:// or https://" v-model="field.value">
                                        <div v-else-if="field.type === 'boolean'" class="form-check form-switch">
                                            <input class="form-check-input logbook-input" type="checkbox" role="switch" :id="'custom_' + field.id" v-model="field.value">
                                        </div>
                                    </td>
                                    <td v-else-if="index === 0" class="align-middle text-center" :rowspan="editing.ledger.custom.length">
                                         <p class="text-primary fw-bold">Support PIN &amp; POP and unlock access to more Logbook data...</p>
                                         <a href="/store/become-a-vip" target="_blank" class="btn btn-primary btn-sm text-light"><i class="fa-solid fa-trophy-star fa-lg"></i> BECOME A V.I.P.</a>
                                    </td>
                                    </template>
                                </tr>

                            </tbody>
                        </table>
                        
                        <div v-if="dataError" class="alert alert-danger text-center" role="alert">
                            {{ dataError }}
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i class="fa-regular fa-rotate-left"></i> Cancel</button>
                        <button @click="updateLedger" type="button" class="btn btn-success text-light ms-3"><i class="fa-solid fa-check"></i> Save</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "CollectionLedger",
        props: ['fields', 'collection', 'itemType', 'isMember'],
        data() {
            return {
                myCollection: this.collection,
                editing: false,
                defaultLedger: {
                    'added_at': null,
                    'added_method': null,
                    'bought_price': null,
                    'added_trade_id': null,
                    'condition': null,
                    'removed_at': null,
                    'removed_method': null,
                    'sold_price': null,
                    'removed_trade_id': null,
                    'custom': this.fields
                },
                dataError: false,
                removeConfirm: false
            }
        },
        watch: {
            // collection: function (newVal, oldVal) {
            //     this.myCollection = newVal;
            // }
        },
        mounted() {
            document.getElementById('manageLedger').addEventListener('hidden.bs.modal', () => {
                this.editing = false;
                // VueEvent.$emit('modifiedTags', this.selectedTags);
            });
        },
        created() {
            this.myCollection = this.myCollection.filter(c => {
                if (c.ledger) {
                    c.ledger.added_at = c.ledger.added_at ? c.ledger.added_at.substring(0, 10) : null;
                    c.ledger.removed_at = c.ledger.removed_at ? c.ledger.removed_at.substring(0, 10) : null;

                    c.ledger.custom = JSON.parse(JSON.stringify(this.fields));

                    c.ledger.custom.filter(f => {
                        let customValue = c.ledger.custom_values.find(v => v.collection_ledger_field_id === f.id);

                        if (customValue) {
                            if (f.type === 'boolean') {
                                f.value = !!customValue.value_boolean ? true : false;
                            } else if (f.type === 'price') {
                                f.value = customValue.value_price;
                            } else if (f.type === 'number') {
                                f.value = customValue.value_number;
                            } else if (f.type === 'date') {
                                f.value = customValue.value_date;
                            } else if (f.type === 'text') {
                                f.value = customValue.value_text;
                            } else if (f.type === 'textarea') {
                                f.value = customValue.value_textarea;
                            } else if (f.type === 'url') {
                                f.value = customValue.value_url;
                            }
                        } else {
                            f.value = null;
                        }
                    });
                } else {
                    c.ledger = JSON.parse(JSON.stringify(this.defaultLedger));
                    c.ledger.collection_id = c.id;
                }
                
                return c;
            });
        },
        computed: {
            //
        },
        methods: {
            
            capitalize: function(str = '') {
                return str && str.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : null;
            },

            updateLedger: function() {
                this.dataError = false;
                axios.post('/my/logbook', this.editing.ledger).then(response => {
                    let collectible = this.myCollection.find(c => c.id === this.editing.id);
                    collectible.ledger = this.editing.ledger;
                    collectible.ledger.id = response.data.id;
                    collectible.ledger.custom_values = response.data.custom_values;
                    bootstrap.Modal.getInstance(document.getElementById('manageLedger')).hide();
                }).catch(error => {
                    console.log(error.response.data.message);
                    this.dataError = error.response.data.message;
                });
            }

        }
    }
</script>